import React from "react";
import { useLang } from "../lib/LangContext";
import { Reveal } from "./Reveal";
import { TID } from "../lib/testIds";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1747574172799-5ef1d0fcd8f4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxzd2l0emVybGFuZCUyMGFscHMlMjBtb2Rlcm58ZW58MHx8fHwxNzgwNTY5MDAyfDA&ixlib=rb-4.1.0&q=85";

export default function About() {
  const { t } = useLang();
  return (
    <section
      id="about"
      data-testid={TID.aboutSection}
      className="relative bg-white py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <Reveal className="lg:col-span-5">
            <div className="relative aspect-[4/5] overflow-hidden bg-black">
              <img
                src={ABOUT_IMG}
                alt="Schweizer Alpen"
                className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                loading="lazy"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                <p className="text-white text-xs uppercase tracking-[0.3em]">9100 Herisau · CH</p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={100} className="lg:col-span-7 lg:pt-12">
            <span className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] font-semibold">
              — {t.about.eyebrow}
            </span>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-black tracking-tight mt-4 leading-tight">
              {t.about.title}
            </h2>
            <p className="mt-8 text-lg text-zinc-700 leading-relaxed max-w-2xl">
              {t.about.text}
            </p>

            <div className="mt-12 grid grid-cols-3 gap-6">
              {t.about.stats.map((s, i) => (
                <div key={i} className="border-t border-black/15 pt-4">
                  <div className="font-display text-3xl sm:text-4xl text-black">{s.value}</div>
                  <div className="mt-2 text-xs uppercase tracking-[0.2em] text-zinc-500">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
